import { FC, ReactElement, memo } from 'react';
import { IProductWarningProps, ProductWarningIconType } from '../../ProductWarning';
import { Icons } from '~/assets/fonts/Icons/icons';
import theme from '~/constants/styles';
import Icon from '~/view/components/Controls/Icon/Icon';

type TProps = Pick<IProductWarningProps, 'iconType' | 'iconSize'>;

export const ProductWarningIcon: FC<TProps> = memo((props: TProps): ReactElement => {
  const { iconType = ProductWarningIconType.TRIANGLE, iconSize = 15 } = props;

  if (iconType === ProductWarningIconType.CIRCLE) {
    return (
      <div className="product-warning-icon__circle" style={{ height: iconSize * 1.2, width: iconSize * 1.2 }}>
        <div className="product-warning-icon__circle-range" style={{ height: iconSize, width: iconSize }}>
          <p className="text-uppercase color-white" style={{ fontSize: iconSize * 0.7 }}>
            !
          </p>
        </div>
      </div>
    );
  }

  return <Icon name={Icons.Warning} size={iconSize} color={theme.colors.red} />;
});
